<template>
    <div class="helper-item">
        <div :class="['decorator']">
            <slot name="Decorator">
                <i v-if="state === 'success'" class="fas fa-check-circle success"></i>
                <i v-else-if="state === 'disabled'" class="fas fa-times-circle disabled"></i>
                <i v-else class="fas fa-arrow-circle-right pending"></i>
            </slot>
        </div>
        <div class="text"><slot></slot></div>
    </div>
</template>

<script>
    export default {
        name: "RequiredActionItem",
        props: {
            state:String
        }
    }
</script>

<style scoped>
    i {
        font-size:24px;
    }
    .success {
        color: #89C42C;
        background:white;
    }
    .disabled {
        color: #D2D2D2;
        background: white;
    }
    .pending {
        color: #666F77;
        background: white;
    }
</style>